import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block4() {

    return (
            <section className="home22-cta-2 at-home19 layout-pb-60">
                <div className="auto-container">
                    <div className="row d-flex align-items-stretch">

                        <div className="image-content wow fadeInLeft col-xl-6 pe-0 d-flex justify-content-center align-items-center" style={{flex: "1"}}>
                            <img src="/images/resource/support-client.jpg" alt="support-client" className="homepage" style={{maxWidth: "100%", height: "100%", objectFit: "cover"}} />
                        </div>

                        <div className="content-column wow fadeInRight col-xl-6 homepage">
                            <div className="inner-column">
                                <div className="mb-0">
                                    <h2 className="title homepage left mb50">5 bonnes raisons de choisir la Hotline Talents Handicap</h2>
                                    <p className="text-white">La Hotline Talents Handicap est un service personnalisé qui bénéficie de notre forte expertise du handicap au travail,
                                        fruit de nos différents dispositifs dans les domaines Recrutement, Formation, Sensibilisation et Communication.</p>
                                    <ul className="list-style-one at-home19 homepage mt20">
                                        <li>Un service TOUT EN UN, personnalisé et livré clés en main, qui prend en compte votre propre politique handicap </li>
                                        <li>Un espace attractif, simple et intuitif, accessible à tous</li>
                                        <li>Une équipe d’experts du handicap au travail pour apporter des réponses claires et un soutien concret à vos collaborateurs</li>
                                        <li>La garantie d’un accompagnement confidentiel qui répond aux besoins uniques de chaque collaborateur</li>
                                        <li>Les données anonymes vous sont remontées pour mieux connaître les besoins et les attentes de vos collaborateurs</li>
                                    </ul>

                                    <ContactModal textButton="Demander une  présentation personnalisée" showText={false} small="small" linkPageContact={false} iframe={false} couleur={true} formModal={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block4;
